import { applicationTypes, scriptTypes } from 'constants/scripts';
import { compact, uniq, get } from 'lodash';
import { getScriptTypeForScript } from 'scripts/selectors';
import {
  getNumZonesWithSeedApplications,
  getSeedApplicationProductsInZones,
  getSeedSummaryForZone
} from 'scripts/zones/planting-selectors';
import {
  getFertilizerApplicationProductsInZones,
  getFertilizerSummaryForZone,
  getNumZonesWithApplications,
  getNumZonesWithFertilizerApplications,
  getProductsInZones
} from 'scripts/zones/fertility-selectors';
import { getApplicationsForZoneByType } from './selectors';

export const getNumZonesWithProductApplications = (script) => {
  const { zones } = script;
  const scriptType = getScriptTypeForScript(script);
  switch (scriptType) {
    case scriptTypes.APPLICATION:
      return getNumZonesWithApplications({ zones, applicationType: applicationTypes.APPLICATION });
    case scriptTypes.FERTILITY:
      // TODO Change these specific functions to above generic function
      return getNumZonesWithFertilizerApplications(zones);
    case scriptTypes.PLANTING:
      return getNumZonesWithSeedApplications(zones);
    default:
      return undefined;
  }
};

export const getProductApplicationProductsInZones = ({ scriptType, zones }) => {
  let products;
  switch (scriptType) {
    case scriptTypes.FERTILITY:
      products = getFertilizerApplicationProductsInZones(zones);
      break;
    case scriptTypes.APPLICATION:
      products = getProductsInZones({ zones, applicationType: applicationTypes.APPLICATION });
      break;
    case scriptTypes.PLANTING:
      products = getSeedApplicationProductsInZones(zones);
      break;
    default:
      products = [];
      break;
  }

  return compact(products);
};

export const getProductSummaryForZone = ({ scriptType, zone }) => {
  switch (scriptType) {
    case scriptTypes.APPLICATION:
      return getApplicationsForZoneByType({ zone, applicationType: applicationTypes.APPLICATION })[0];
    case scriptTypes.FERTILITY:
      return getFertilizerSummaryForZone(zone);
    case scriptTypes.PLANTING:
      return getSeedSummaryForZone(zone);
    default:
      return {};
  }
};

export const getIncorporationMethodForZones = (zones) => {
  const methods = Object.values(zones).map((zone) => {
    return get(zone, `meta.applications.${applicationTypes.APPLICATION}[0].incorporationMethod`);
  });
  return uniq(methods)[0];
};
